export default __webpack_public_path__ + "static/signature_form-95591311a7b94765fecdad29fa555c94.jpg";